/**
 * Allowlist de esquemas para `href`/`src` renderizados a partir de conteúdo do
 * editor/importado/scrapeado. Defesa-em-profundidade contra `javascript:`/`data:`/
 * `vbscript:` (o React já neutraliza `javascript:` em href, mas saneamos na entrada
 * por robustez e para alinhar o caminho JSX ao conversor HTML do Payload).
 */
const SAFE_SCHEMES = new Set(['http:', 'https:', 'mailto:', 'tel:'])

/** Detecta caracteres de controlo C0 (0x00-0x1F, inclui CR/LF/TAB) e DEL (0x7F) — anti CRLF/URL injection. */
function hasControlChars(s: string): boolean {
  for (let i = 0; i < s.length; i++) {
    const code = s.charCodeAt(i)
    if (code <= 0x1f || code === 0x7f) return true
  }
  return false
}

export function isSafeHref(raw: string | null | undefined): boolean {
  if (!raw) return false
  const t = raw.trim()
  if (!t) return false
  if (t.startsWith('//')) return false // protocol-relative (//evil.com)
  if (hasControlChars(t)) return false
  let u: URL
  try {
    // Base resolve hrefs relativos (/x, foo, #frag) para um esquema seguro;
    // hrefs absolutos mantêm o próprio esquema, que é validado abaixo.
    u = new URL(t, 'https://relative.invalid/')
  } catch {
    return false
  }
  return SAFE_SCHEMES.has(u.protocol)
}

/** Retorna `raw` se for um href seguro; caso contrário, o `fallback` (padrão `#`). */
export function sanitizeHref(raw: string | null | undefined, fallback = '#'): string {
  return isSafeHref(raw) ? (raw as string).trim() : fallback
}
